(function () {
  'use strict';

  // Adds desktop mouse-drag scrolling on top of Taste's native
  // <slider-component> (which already handles touch swipe, trackpad
  // scroll, buttons, and keyboard via global.js — this only fills the one
  // gap Dawn's slider doesn't cover). Purely manipulates scrollLeft, so
  // SliderComponent's own scroll listener (counter/disabled-state updates)
  // keeps working unmodified regardless of what caused the scroll.
  function addDragScroll(track) {
    var isDragging = false, dragStartX = 0, dragStartScroll = 0, dragMoved = false;
    track.addEventListener('mousedown', function (e) {
      isDragging = true;
      dragMoved = false;
      track.classList.add('is-dragging');
      dragStartX = e.pageX;
      dragStartScroll = track.scrollLeft;
    });
    ['mouseleave', 'mouseup'].forEach(function (evt) {
      window.addEventListener(evt, function () {
        isDragging = false;
        track.classList.remove('is-dragging');
      });
    });
    track.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      e.preventDefault();
      var delta = e.pageX - dragStartX;
      if (Math.abs(delta) > 3) dragMoved = true;
      track.scrollLeft = dragStartScroll - delta;
    });
    track.addEventListener('click', function (e) {
      if (dragMoved) { e.preventDefault(); dragMoved = false; }
    }, true);
  }

  document.querySelectorAll('[data-gb-drag-scroll]').forEach(addDragScroll);

  // Generic pagination-dot pagination for mobile-only slider-component
  // carousels (Ritual Stories, Explore Our Rituals). Dots are generated
  // from the slider's own slide count rather than hardcoded in Liquid, and
  // stay in sync with native touch-swipe/scroll-snap scrolling — no
  // duplicate slide-tracking logic needed.
  function initDotPagination(dotsEl) {
    var sliderId = dotsEl.getAttribute('data-gb-dots-for');
    var target = sliderId && document.getElementById(sliderId);
    var track = target && (target.matches('ul,ol') ? target : target.querySelector('ul,ol'));
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;

    // Optional data-gb-dots-step="2" groups every N slides under one dot
    // (e.g. Best Sellers: 6 products, 3 dots — one per pair) instead of the
    // default one-dot-per-slide used elsewhere (Ritual Stories, Ritual Cards).
    var step = parseInt(dotsEl.getAttribute('data-gb-dots-step'), 10) || 1;
    var groupStarts = [];
    for (var g = 0; g < slides.length; g += step) groupStarts.push(slides[g]);
    if (groupStarts.length < 2) return;

    var dots = groupStarts.map(function (slide, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'gb-dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', function () {
        slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
      dotsEl.appendChild(dot);
      return dot;
    });

    var ticking = false;
    function updateActive() {
      ticking = false;
      var trackLeft = track.getBoundingClientRect().left;
      var closest = 0, closestDist = Infinity;
      groupStarts.forEach(function (slide, i) {
        var dist = Math.abs(slide.getBoundingClientRect().left - trackLeft);
        if (dist < closestDist) { closestDist = dist; closest = i; }
      });
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === closest); });
    }
    updateActive();
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateActive);
    }, { passive: true });
    window.addEventListener('resize', updateActive);
  }

  document.querySelectorAll('[data-gb-dots-for]').forEach(initDotPagination);

  // Footer nav accordion — mobile only. The <details> elements ship with
  // `open` in the HTML so desktop (where a CSS media query disables the
  // summary's pointer-events and hides the +/× icon) always shows the nav
  // columns with zero JS dependency. On mobile we collapse them once on
  // load, then enforce "only one open at a time" as the user taps around.
  var footerAccordions = document.querySelectorAll('.gb-footer__accordion');
  if (footerAccordions.length) {
    if (window.matchMedia('(max-width: 749px)').matches) {
      footerAccordions.forEach(function (details) { details.open = false; });
    }
    footerAccordions.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        footerAccordions.forEach(function (other) {
          if (other !== details) other.open = false;
        });
      });
    });
  }
})();
